import React from 'react'

import moment, { locale } from 'moment'
import Vimeo from '@u-wave/react-vimeo';

import editImage from '../../images/icons/edit_black.svg';
import VideoThumb from '../video/VideoThumb'
import ThumbUpImg from '../../images/icons/thumb_up_black.svg'
import deleteImage from '../../images/icons/delete_forever_black.svg';
import ShowCategories from '../ui/ShowCategories'
import arrowRight from './images/arrow-right.svg'
import arrowRightDark from './images/arrow-right-dark.svg'
import folderSVG from './images/folder-solid.svg'
import commentSVG from './images/comment-alt-solid.svg'
import ReactHtmlParser from 'react-html-parser';

import DatePicker from 'react-datepicker';
import dateSVG from './images/calendar.svg';
import tickSVG from './images/tick.svg';
import twoTicksSVG from './images/ticksTwo.svg'

import { openCloseMediaUpload, setCurrentSessionInStore, setIsInternalUpload, setSessionName, setScopeAndSessionType, setVisibleUploadComponent } from '../../actions/media_upload'

//import {fetchSessions} from '../../actions/patient'
import 'react-datepicker/dist/react-datepicker.css';

const PatientSessions = ({
	practice,
	patient,
	patient_sessions_array,
	therapy_areas,
	therapy_categories,
	videos,
	openClick,
	notifications,
	isEditable,
	children,
	handleEdit,
	handleDelete,
	toggleShowAssessment,
	filterBy,
	filter,
	filterDate,
	filterByDate,
	homework,
	toggleHomework,
	toggleShowMore,
	toggled,
	gallery
}) => {
	const util = require('util')
	let now = new Date().getTime();
	
		// console.log(util.inspect(patient_sessions_array, false, null, true /* enable colors */))

	function displayAge(birth, target) {
		let months = target.diff(birth, 'months', true)
		let birthSpan = {
			year: Math.floor(months / 12),
			month: Math.floor(months) % 12,
			day: Math.round((months % 1) * target.daysInMonth(), 0)
		}
		// you can adjust below logic as your requirements by yourself
		if (birthSpan.year < 1 && birthSpan.month < 1) {
			return birthSpan.day + ' day' + (birthSpan.day > 1 ? 's' : '')
		} else if (birthSpan.year < 1) {
			return birthSpan.month + ' month' + (birthSpan.month > 1 ? 's ' : ' ') + birthSpan.day + ' day' + (birthSpan.day > 1 ? 's' : '')
		} else if (birthSpan.year < 2) {
			return birthSpan.year + ' year' + (birthSpan.year > 1 ? 's ' : ' ') + birthSpan.month + ' month' + (birthSpan.month > 1 ? 's ' : '')
		} else {
			return birthSpan.year + ' year' + (birthSpan.year > 1 ? 's' : '')
		}
	}

	// Session Media Upload
	function toggleMediaUpload(bool, uploadType){
		console.log(patient)
		if(bool){
			setVisibleUploadComponent(uploadType)
			setScopeAndSessionType({scope: "internal", sessionType: null, parent: false, therapist: true})
			setCurrentSessionInStore({patient: patient._id})
		}
		openCloseMediaUpload(bool)
	}


	function setSessionKey(session) {
		return session.type + '-' + session.data._id;
	}

	function setHomeworkId(session) {
		return 'homework-' + setSessionKey(session);
	}

	function ticks(session, isEditable) {
		if (session.data.sent || !isEditable) {
			if (session.data.parent_opened !== undefined && session.data.parent_opened) {
				// Two ticks
				return  <div className="ticks"><img src={twoTicksSVG} alt="Sent" /></div>
			}
			// One Tick
			return <div className="ticks"><img src={tickSVG} alt="Opened" /></div>
		}
		// No ticks - still a draft
		return '';
	}

	function loadSessionAndAssessments() {
		if (filter === 'all' || filter === 'sessions' || filter === 'assessments') {
			return patient_sessions_array.length && patient._id ? patient_sessions_array.map(session => <div key={setSessionKey(session)}>
				{/* <div className="spacerTopBottom"></div> */}

				{/* ASSESMENT CARD */}
				{session.type === 'assessment' && <div>
					<ul className="md-list card assesmentCard marginless">
						<li className="card-header row marginTopNone">
							<div className="patientSessionOrAssesmentIcon">
								<span>A</span>
							</div>
							<div className="headerInfo">
								<p>{(now - (Date.parse(session.date) / 86400000)) > 2 ?
									moment(session.date).format('ddd Do of MMM YYYY') : moment(session.date).fromNow()}
								</p>
								<small>Therapist: {session.data.therapist.name} | Patient Age: {displayAge(moment(session.data.patient.dob), moment(session.date))}</small>
							</div>
							<div className="headerAction">
								<a className="link padding textWhite" onClick={() => toggleShowAssessment(session.data)}>OPEN</a>
							</div>
						</li>
						
						<li className="internalNotes">
							{/* <h5>Internal Notes:</h5> */}
							<div className={ toggled === session.data._id ? 'notesContainer show' : 'notesContainer' }>
							{ session.data.internal_notes !== '' ? ReactHtmlParser(session.data.internal_notes) : ReactHtmlParser(session.data.internal_notes_array) }
							</div>
							<div className="readMoreContainer">
								<a onClick={() => {toggleShowMore(session.data._id)} }> {toggled === session.data._id ? 'Read Less': 'Read More'}</a>
							</div>
						</li>

						<li className="categoriesSection">
							<div className="catogories">
								<ShowCategories
									therapy_areas={session.data.therapy_areas.map(areaId => therapy_areas[areaId])}
									therapy_categories={therapy_categories} />
							</div>
							<div className="commentAndDocs">
								<div className="documents">
									<img src={folderSVG} />
									<p>{session.data.documents.length} Documents</p>
								</div>
							</div>
						</li>
					</ul>
					<div className="hrAssesment">
						<span></span>
					</div>
				</div>}
				{/* ASSESMENT CARD */}

				{/* SESSION CARD */}
				{session.type === 'session' && <div>
					<ul className="md-list sessionCard card marginless">
					{ ticks(session, isEditable) }
						<li className="card-header row marginTopNone">
							<div className="patientSessionOrAssesmentIcon">
								<span>S</span>
							</div>
							<div className="headerInfo">
								<p>
									{
										(!session.data.sent && isEditable) && <span className="">DRAFT - </span>
									}
									{(now - (Date.parse(session.data.created) / 86400000)) > 2 ?
									moment(session.data.created).format('ddd Do of MMM YYYY h:mm a') : moment(session.data.created).fromNow()}
								</p>
								<small>Therapist: {session.data.therapist.name}</small>
							</div>
							<div className="headerAction">
								{
									(session.data.sent || !isEditable) && <a className="link padding" onClick={() => {
										openClick(session.data)
									}
									}>OPEN</a>
								}
								{(handleEdit && (!session.data.sent && isEditable)) && <div
									onClick={() => { handleEdit(session.data) }}
									className="edit padding icon link">
									<img src={editImage} alt="Edit" />
								</div>
								}
								{(handleDelete && (!session.data.sent && isEditable)) && <div
									onClick={() => { handleDelete(session.data._id) }}
									className="edit padding icon link">
									<img src={deleteImage} alt="Delete" />
								</div>
								}
								
							</div>
						</li>
						{/* <li className="card-content">
					<p>{session.data.internal_notes}</p>
				</li> */}

						<li className="internalNotes">
							{/* <h5>Internal Notes:</h5> */}
							<div className={ toggled === session.data._id ? 'notesContainer show' : 'notesContainer' }>
								{ session.data.internal_notes !== '' ? ReactHtmlParser(session.data.internal_notes) : ReactHtmlParser(session.data.internal_notes_array) }
							</div>
							<div className="readMoreContainer">
								<a onClick={() => {toggleShowMore(session.data._id)} }> {toggled === session.data._id ? 'Read Less': 'Read More'}</a>
							</div>
						</li>
					
						<li>

							<ShowCategories
								therapy_areas={session.data.therapy_areas.map(areaId => therapy_areas[areaId])}
								therapy_categories={therapy_categories} />
						</li>
						<li className="homeWorkSection" className={homework === setHomeworkId(session) ? "homeWorkSection show" : "homeWorkSection"}>
							<div onClick={() => { toggleHomework(setHomeworkId(session)) }} className="md-subhead"><a >Homework Areas</a></div>
							<div id={setHomeworkId(session)} className={homework === setHomeworkId(session) ? "video-grid show grid horizontal-row" : "video-grid grid horizontal-row"}>
								<div className="videoContainer">
									{session.data.videos.map(videoId => <div className="thumb" key={videoId}>
										<div className="card marginless">
											{videos[videoId] && <VideoThumb className="min-video" video={videos[videoId]} />}
											{session.data.videos_done[videoId] && <img alt="Avatar" src={ThumbUpImg} style={{
												height: '18px',
												position: 'absolute',
												right: '4px',
												bottom: '4px'
											}} />}
										</div>
									</div>)}
								</div>
							</div>
						</li>
						{notifications[session.data._id] > 0 && <div className="notification link" onClick={() => {
							openClick(session.data)
						}
						}>
							{notifications[session.data._id]}
						</div>}
					</ul>
					<div className="hrAssesment">
						<span></span>
					</div>
				</div>}
			</div>)
				:
				<div><p>Loading...</p></div>
		}
		return null;
	}

	function loadPhotos() {
		if (filter === 'photos') {
			if (practice && practice.mediaStorageAddonEnabled) {
				return <div className="photoFilterWrapper">
					<button onClick={(e) => toggleMediaUpload(true, "uploadPhoto")}>
						<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus-square" className="svg-inline--fa fa-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg>
						Add Photo
					</button>
					<div>
						{gallery.items.length ? gallery.items.map(gal =>
							{ return gal.media == 'photo' && <div className="media-placeholder" key={gal.id}>
								<div className="thumb">
									<img src={gal.url}/>
								</div>
								<div className="info">
									{ mediaIsApartOfSession(gal.id, gal.scope) }
									<span>{moment(gal.modified).format('ddd Do of MMM YYYY h:mm a')}</span>
								</div>
							</div>}
						): <div>No Images</div>}
					</div>
				</div>
			}
			return <div><p>You do not have permission for this feature.</p></div>
		}
		return null;
	}

	function loadDocuments() {
		if (filter === 'documents') {
			if (practice && practice.mediaStorageAddonEnabled) {
				return <div className="documentFilterWrapper">
					<button onClick={(e) => toggleMediaUpload(true, "uploadDocument")}>
					<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus-square" class="svg-inline--fa fa-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg>
						Add Document
					</button>
					<div>
						{gallery.items.length ? gallery.items.map(gal =>
							{ return gal.media == 'document' && <div className="media-placeholder" key={gal.id}>
								<div className="thumb document">
									<a href={gal.url} target="_blank">
										<svg fill="#c11515"  aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-pdf" className="svg-inline--fa fa-file-pdf fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#c11515" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path></svg>
											<span>
												{gal.filename ? gal.filename : "File"}
							<small>{new Date(gal.modified).toLocaleDateString('en-GB',{weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})} at {new Date(gal.modified).getHours()}:{new Date(gal.modified).getMinutes()}</small>
											</span>
									</a>
								</div>
								<div className="info">
									{ mediaIsApartOfSession(gal.id, gal.scope) }
									<span>{moment(gal.modified).format('ddd Do of MMM YYYY h:mm a')}</span>
								</div>
							</div>}
							
						): <div>No Documents</div>}
					</div>
				</div>
			}
			return <div><p>You do not have permission for this feature.</p></div>
		}
		return null;
	}

	function handleVideoOnError(e) {
		console.log(e);
	} 

	function loadVideos() {
		if (filter === 'videos') {
			if (practice && practice.mediaStorageAddonEnabled) {
				return <div className="videoFilterWrapper">
					<button onClick={(e) => toggleMediaUpload(true, "uploadVideo")}>
						<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus-square" className="svg-inline--fa fa-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path></svg>
						Add Video
					</button>
					<div>
						{gallery.items.length ? gallery.items.map(gal =>
							{ return (gal.media == 'video' &&
								gal.url !== undefined &&
								gal.url !== 'Uploading Video' &&
								gal.url !== 'Failed to upload Video'
								) && <div className="media-placeholder" key={gal.id}>
									<div className="thumb video">
										<Vimeo
											responsive={true}
											video={gal.url.replace("/videos/", "")}
											onError={(e) => handleVideoOnError(e)}
										/>
									</div>
									<div className="info">
										{ mediaIsApartOfSession(gal.id, gal.scope) }
										<span>{moment(gal.modified).format('ddd Do of MMM YYYY h:mm a')}</span>
									</div>
								</div>
								
							}
							
						): <div>No Videos</div>}
					</div>
				</div>
			}
			return <div><p>You do not have permission for this feature.</p></div>
		}
		return null;
	}

	function mediaIsApartOfSession(galleryId, galleryScope) {
		if (patient_sessions_array.length) {
			// console.log('Session');
			let findSessionIndex = patient_sessions_array.findIndex((session) => {
				// console.log(session);
				if (session.data !== undefined && session.data.gallery !== undefined && session.data.gallery.length) {
					// console.log('Gallery');
					// console.log('Gallery Id:', galleryId);
					let findGalleryIndex = session.data.gallery.findIndex((gal) => {
						// console.log(gal)
						if (gal == galleryId) {
							// console.log('found');
							return true;
						}
						return false;
					});

					// console.log('Gallery Index:', findGalleryIndex)
					if (findGalleryIndex > -1) {
						return true;
					}
				}
				return false;
			})

			if (findSessionIndex > -1) {
				let session = patient_sessions_array[findSessionIndex];
				return <div>
					<span className="scopeText">{galleryScope}</span>
					{
						(session.data.sent || !isEditable) && <a className="link padding right" onClick={() => {
							openClick(session.data)
						}
						}>VIEW SESSION</a>
					}
					{(handleEdit && (!session.data.sent && isEditable)) && <div
						onClick={() => { handleEdit(session.data) }}
						className="edit padding icon link right">
						<img src={editImage} alt="Edit" />
					</div>
					}
				</div>
			}
		}
		
		return '';
	}

	return Object.keys(therapy_areas).length ? <div className="mb8">
		{children}
		{/* FILTER */}
		<div className="typeAndDateFilter">
			<div className="typeFilter">
				<label htmlFor="typeFilter">Type:</label>
				<select name="typeFilter" id="typeFilter" onChange={filterBy} value={filter}>
					<option value="all">Sessions and Assessments</option>
					<option value="sessions">Sessions</option>
					<option value="assessments">Assessments</option>
					<option value="photos">Photos</option>
					<option value="documents">Documents</option>
					<option value="videos">Videos</option>
				</select>
			</div>
			<DatePicker
				popperPlacement="bottom-end"
				selected={filterDate}
				onChange={filterByDate}
				placeholderText="From Date"
				dateFormat="YYYY/MM/DD"
				showYearDropdown
			/>
		</div>
		{/* FILTER */}
		{loadSessionAndAssessments()}
		{loadPhotos()}
		{loadDocuments()}
		{loadVideos()}

	</div>
		: <p>Loading...</p>;
	{/* SESSION CARD */ }

}

PatientSessions.defaultProps = {
	patient: {},
	notifications: {},
	patient_sessions_array: [],
	therapy_areas: {},
	videos: {},
	editButton: false
}

export default PatientSessions



// WEBPACK FOOTER //
// ./src/components/therapist/PatientSessions.jsx